import React, { useState, useEffect, useContext } from 'react'
import apiClient from './utils/apiClient'

export const AuthContext = React.createContext()
export const useAuth = () => useContext(AuthContext)

export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [status, setStatus] = useState(null)

  useEffect(() => {
    apiClient.get('/api/auth/me').then(
      ({ data }) => {
        setStatus(data)
        setLoading(false)
      },
      () => {
        setStatus({ authenticated: false })
        setLoading(false)
      }
    )
  }, [])

  const value = {
    loading,
    isAuthenticated: !!(status && status.authenticated),
    hasAccess: !!(status && status.hasAccess),
    isSudo: !!(status && status.isSudo),
    roles: (status && status.roles) || [],
    requiredRole: status && status.requiredRole,
    user: status && status.user,
    logout: () => { window.location.href = '/auth/logout' }
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
